// package
import { Fragment, useState, useEffect } from "react";
import { Link, useSearchParams, useNavigate } from "react-router-dom";
import {
  Button,
  Card,
  Col,
  Row,
  OverlayTrigger,
  Tooltip,
  Form,
  Spinner
} from "react-bootstrap";
import AmlHashForm from "aml-hash-form";

// component
import PageBreadcrumb from "elements/System/PageBreadcrumb";
import AgDelete from "elements/System/AgDelete";
import AgStatus from "elements/System/AgStatus";
import { api, common } from "includes";
import UnitColorsPanel from "./UnitColorsPanel";

export default function LocalityForm() {
  // const
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  let mode = searchParams.get("mode");
  let id = searchParams.get("id");

  // state
  const [process, setProcess] = useState<any>({ result: 100 });
  const [confirm, setConfirm] = useState<any>({ id: null, type: null });
  const [submit, setSubmit] = useState<any>("");
  const [resultList, setResultList] = useState<any>(null);
  // Unit chip colors are a super-admin-only section (hidden from admins entirely).
  const [auth] = useState<any>(common.getAuth());
  const isSuper = auth?.role === "super";
  const [permission] = useState(common.getUserPermission());

  // form
  const formFields = {
    name: { validate: ["req#Name is required"] },
    state: { validate: ["req#State is required"] },
    // latitude: { validate: ["req#Latitude is required"] },
    // longitude: { validate: ["req#Longitude is required"] },
    twitterPage: { validate: [] },
    twitterAppKey: { validate: [] },
    twitterAppSecret: { validate: [] },
    twitterAccessToken: { validate: [] },
    twitterAccessSecret: { validate: [] },
    twitterBearerToken: { validate: [] },
    newsRssFeedURL: { validate: [] },
    subscriberOnlyComment: { validate: [], value: false },
    field1Name: { validate: [] },
    field2Name: { validate: [] },
    field3Name: { validate: [] },
    field4Name: { validate: [] },
    field5Name: { validate: [] }
  };

  const {
    fields,
    errors,
    handleChange,
    handleSubmit,
    setValue,
    setMultiValue,
  } = AmlHashForm(formFields);

  // effect
  useEffect(() => {
    if (id) {
      getData();
    } else {
      processState("result", 200)
    }
  }, []);

  useEffect(() => {
    if (id) {
      getData();
    } else {
      processState("result", 200)
    }
  }, [mode]);

  // api 
  const getData = () => {
    processState("result", 100)
    let data: any = {
      url: `admin/locality/${id}`,
      method: "GET",
    };
    api.call(
      data,
      (res: any) => {
        processState("result", res.status)
        if (res.status === 200) {
          let result = res.data;
          setResultList(result);
          setMultiValue({
            name: result.name || "",
            state: result.state || "",
            // latitude: result.latitude || "",
            // longitude: result.longitude || "",
            twitterPage: result.twitterPage || "",
            twitterAppSecret: result.twitterAppSecret || "",
            twitterAppKey: result.twitterAppKey || "",
            twitterAccessToken: result.twitterAccessToken || "",
            twitterAccessSecret: result.twitterAccessSecret || "",
            twitterBearerToken: result.twitterBearerToken || "",
            newsRssFeedURL: result.newsRssFeedURL || "",
            subscriberOnlyComment: result.subscriberOnlyComment || false,
            field1Name: result.field1Name || "",
            field2Name: result.field2Name || "",
            field3Name: result.field3Name || "",
            field4Name: result.field4Name || "",
            field5Name: result.field5Nam || ""
          });
        }
      }
    );
  };

  const save = () => {
    let data = common.formPayload(fields, []);
    let param = {
      url: id ? `admin/locality/${id}` : `admin/locality`,
      method: id ? "PUT" : "POST",
      body: data,
    };

    api.call(
      param,
      (res: any) => {
        if (res.status === 200) {
          common.notify("S", "Locality updated successfully");
          if (id) {
            navigate(`/locality/form?id=${id}&mode=view`);
            processState("result", 100)
            getData();
          } else {
            navigate(`/locality/list`);
          }
        } else {
          common.notify("E", res?.data.error);
        }
        setSubmit("");
      }
    );
  };

  const deleteLocality = () => {
    let data: any = {
      url: `admin/locality/${confirm.id}`,
      method: "DELETE",
    };

    api.call(data, (res: any) => {
      if (res.status === 200) {
        setConfirm({ id: null, type: "" });
        common.notify("S", "Locality deleted successfully");
        navigate(`/locality/list`);
      } else {
        common.notify("E", res.error);
      }
    });
  };

  // events
  const onSubmit = (e: any) => {
    e.preventDefault();
    const isValid = handleSubmit();
    if (isValid) {
      setSubmit("submit");
      save();
    }
  };

  const deleteCallBack = (isDelete: boolean) => {
    if (isDelete) {
      deleteLocality();
    } else {
      setConfirm({ id: null, type: "" });
    }
  };

  // callback
  const onAgCallBack = (status: any) => {
    getData();
  };

  // support
  const processState = (label: any, value: any) => {
    setProcess((prev: any) => ({
      ...prev,
      [label]: value
    }));
  }

  return (
    <Fragment>
      <PageBreadcrumb
        breadCrumbItems={[
          { label: "Localities", path: "/locality/list" },
          { label: "Locality Form", path: "", active: true },
        ]}
        title={"Locality Form"}
      />
      {process.result != 200 ? (
        <AgStatus
          process={process.result}
          message={{
            100: "Loading... Please wait!",
            404: "Something went wrong! Please Refresh Again",
          }}
          button={{ 400: "Refresh", 404: "Refresh" }}
          size="l"
          onAgCallBack={onAgCallBack}
        />
      ) : (<Fragment>
        {mode != "view" ? (
          <Fragment>
            {" "}
            <Row>
              <Col xl={12} lg={12}>
                <Card>
                  <Card.Body className="py-1 px-1 border-bottom border-light">
                    <div className="d-flex align-items-center justify-content-between">
                      <div className="float-start">
                        <OverlayTrigger
                          placement="bottom"
                          overlay={<Tooltip id="">Back</Tooltip>}
                        >
                          <Link
                            to="/locality/list"
                            className="text-reset fs-20 p-1 d-inline-block"
                          >
                            <i
                              className="ri-arrow-left-s-line pe-2"
                              data-bs-container="#tooltips-container"
                              data-bs-toggle="tooltip"
                            />
                          </Link>
                        </OverlayTrigger>
                        <label className="form-check-label fs-16">{id ? "Edit" : "Add"} Locality</label>
                      </div>
                      <div id="tooltips-container d-flex align-items-center">
                        <div className="d-flex flex-wrap gap-2">
                          <Button variant="secondary" onClick={() => { navigate("/locality/list") }} disabled={submit === "submit"}>
                            <i className=" ri-arrow-go-back-line me-1" />
                            Cancel
                          </Button>
                          <Button variant="primary" onClick={onSubmit} disabled={submit === "submit"}>
                            {submit === "submit" ? (
                              <>
                                <Spinner className="spinner-border-sm me-1" color="white" />
                                Processing...
                              </>
                            ) : (
                              <>
                                <i className="ri-save-line" /> Save
                              </>
                            )}
                          </Button>
                        </div>
                      </div>
                    </div>
                  </Card.Body>
                </Card>
              </Col>
            </Row>
            <Row>
              <Form>
                <Card>
                  <Card.Body>
                    <Row>
                      <Col md={6}>
                        <Form.Group className="mb-3">
                          <Form.Label>Name</Form.Label>
                          <Form.Control
                            type="text"
                            name="name"
                            id="singleLine"
                            maxLength={100}
                            data-toggle="maxlength"
                            placeholder="Enter name"
                            value={fields.name}
                            onChange={handleChange}
                            isInvalid={errors.name ? true : false}
                          />
                          <Form.Control.Feedback type="invalid">
                            {errors.name}
                          </Form.Control.Feedback>
                        </Form.Group>
                      </Col>
                      <Col md={6}>
                        <Form.Group className="mb-3">
                          <Form.Label>State</Form.Label>
                          <Form.Control
                            type="text"
                            name="state"
                            id="singleLine"
                            maxLength={100}
                            data-toggle="maxlength"
                            placeholder="Enter state"
                            value={fields.state}
                            onChange={handleChange}
                            isInvalid={errors.state ? true : false}
                          />
                          <Form.Control.Feedback type="invalid">
                            {errors.state}
                          </Form.Control.Feedback>
                        </Form.Group>
                      </Col>
                      {/* <Col md={6}>
                        <Form.Group className="mb-3">
                          <Form.Label>Latitude</Form.Label>
                          <Form.Control
                            type="text"
                            name="latitude"
                            id="singleLine"
                            maxLength={100}
                            data-toggle="maxlength"
                            placeholder="Enter latitude"
                            value={fields.latitude}
                            onChange={handleChange}
                            isInvalid={errors.latitude ? true : false}
                          />
                          <Form.Control.Feedback type="invalid">
                            {errors.latitude}
                          </Form.Control.Feedback>
                        </Form.Group>
                      </Col>
                      <Col md={6}>
                        <Form.Group className="mb-3">
                          <Form.Label>Longitude</Form.Label>
                          <Form.Control
                            type="text"
                            name="longitude"
                            id="singleLine"
                            maxLength={100}
                            data-toggle="maxlength"
                            placeholder="Enter Longitude"
                            value={fields.longitude}
                            onChange={handleChange}
                            isInvalid={errors.longitude ? true : false}
                          />
                          <Form.Control.Feedback type="invalid">
                            {errors.longitude}
                          </Form.Control.Feedback>
                        </Form.Group>
                      </Col> */}
                      {id &&
                        <Fragment>
                          <Col md={6}>
                            <Form.Group className={"mb-3"}>
                              <Form.Check type="checkbox">
                                <Form.Check.Input type="checkbox" id="subscriberOnlyComment"
                                  name="subscriberOnlyComment"
                                  checked={fields.subscriberOnlyComment}
                                  onChange={(e) => {
                                    setValue("subscriberOnlyComment", e.target.checked)
                                  }
                                  } />
                                <Form.Check.Label htmlFor="subscriberOnlyComment">Subscriber Only Comment</Form.Check.Label>
                              </Form.Check>
                            </Form.Group>
                          </Col>
                          <Col md={12}>
                            <div className="bg-warning-subtle p-2 mb-2">
                              For security purposes, the actual length of the Twitter credentials below will not reflect what is actually stored in the database. If the lengths of the inputs look wrong, <u>that is intentional.</u>
                            </div>
                          </Col>
                          <Col md={6}>
                            <Form.Group className="mb-3">
                              <Form.Label>News RSS Feed Url</Form.Label>
                              <Form.Control
                                type="text"
                                name="newsRssFeedURL"
                                id="singleLine"
                                maxLength={100}
                                data-toggle="maxlength"
                                placeholder="Enter news rss feed URL"
                                value={fields.newsRssFeedURL}
                                onChange={handleChange}
                              />
                            </Form.Group>
                          </Col>
                          <Col md={6}>
                            <Form.Group className="mb-3">
                              <Form.Label>Twitter Description</Form.Label>
                              <Form.Control
                                type="text"
                                name="twitterPage"
                                id="singleLine"
                                maxLength={100}
                                data-toggle="maxlength"
                                value={fields.twitterPage}
                                onChange={handleChange}
                              />
                              <Form.Control.Feedback type="invalid">
                                {errors.twitterPage}
                              </Form.Control.Feedback>
                            </Form.Group>
                          </Col>
                          <Col md={6}>
                            <Form.Group className="mb-3">
                              <Form.Label>Twitter Access Token</Form.Label>
                              <Form.Control
                                type="text"
                                name="twitterAccessToken"
                                id="singleLine"
                                maxLength={100}
                                data-toggle="maxlength"
                                value={fields.twitterAccessToken}
                                onChange={handleChange}
                              />
                            </Form.Group>
                          </Col>
                          <Col md={6}>
                            <Form.Group className="mb-3">
                              <Form.Label>Twitter Access Token Secret</Form.Label>
                              <Form.Control
                                type="text"
                                name="twitterAppSecret"
                                id="singleLine"
                                maxLength={100}
                                data-toggle="maxlength"
                                value={fields.twitterAppSecret}
                                onChange={handleChange}
                              />
                            </Form.Group>
                          </Col>
                          <Col md={6}>
                            <Form.Group className="mb-3">
                              <Form.Label>Twitter API Key</Form.Label>
                              <Form.Control
                                type="text"
                                name="twitterAppKey"
                                id="singleLine"
                                maxLength={100}
                                data-toggle="maxlength"
                                value={fields.twitterAppKey}
                                onChange={handleChange}
                              />
                            </Form.Group>
                          </Col>
                          <Col md={6}>
                            <Form.Group className="mb-3">
                              <Form.Label>Twitter API Secret</Form.Label>
                              <Form.Control
                                type="text"
                                name="twitterAccessSecret"
                                id="singleLine"
                                maxLength={100}
                                data-toggle="maxlength"
                                value={fields.twitterAccessSecret}
                                onChange={handleChange}
                              />
                            </Form.Group>
                          </Col>
                          <Col md={6}>
                            <Form.Group className="mb-3">
                              <Form.Label>Twitter Bearer Token</Form.Label>
                              <Form.Control
                                type="text"
                                name="twitterBearerToken"
                                id="singleLine"
                                maxLength={100}
                                data-toggle="maxlength"
                                value={fields.twitterBearerToken}
                                onChange={handleChange}
                              />
                            </Form.Group>
                          </Col>
                        </Fragment>
                      }
                    </Row>
                  </Card.Body>
                </Card>
                <Card>
                  <Card.Body>
                    <Row>
                      <label className="form-check-label fs-16 mb-3">
                        Definition Information
                      </label>
                      <Col md={6}>
                        <Form.Group className="mb-3">
                          <Form.Label>Field1 Name</Form.Label>
                          <Form.Control
                            type="text"
                            name="field1Name"
                            id="singleLine"
                            maxLength={100}
                            data-toggle="maxlength"
                            value={fields.field1Name}
                            onChange={handleChange}
                          />
                        </Form.Group>
                      </Col>
                      <Col md={6}>
                        <Form.Group className="mb-3">
                          <Form.Label>Field2 Name</Form.Label>
                          <Form.Control
                            type="text"
                            name="field2Name"
                            id="singleLine"
                            maxLength={100}
                            data-toggle="maxlength"
                            value={fields.field2Name}
                            onChange={handleChange}
                          />
                        </Form.Group>
                      </Col>
                      <Col md={6}>
                        <Form.Group className="mb-3">
                          <Form.Label>Field3 Name</Form.Label>
                          <Form.Control
                            type="text"
                            name="field3Name"
                            id="singleLine"
                            maxLength={100}
                            data-toggle="maxlength"
                            value={fields.field3Name}
                            onChange={handleChange}
                          />
                        </Form.Group>
                      </Col>
                      <Col md={6}>
                        <Form.Group className="mb-3">
                          <Form.Label>Field4 Name</Form.Label>
                          <Form.Control
                            type="text"
                            name="field4Name"
                            id="singleLine"
                            maxLength={100}
                            data-toggle="maxlength"
                            value={fields.field4Name}
                            onChange={handleChange}
                          />
                        </Form.Group>
                      </Col>
                      <Col md={6}>
                        <Form.Group className="mb-3">
                          <Form.Label>Field5 Name</Form.Label>
                          <Form.Control
                            type="text"
                            name="field5Name"
                            id="singleLine"
                            maxLength={100}
                            data-toggle="maxlength"
                            value={fields.field5Name}
                            onChange={handleChange}
                          />
                        </Form.Group>
                      </Col>
                      <Col md={12}>
                        <div className="bg-warning-subtle p-2 mb-2">
                          NOTE:To add a facebook page, go to the create incident page
                        </div>
                      </Col>
                    </Row>
                  </Card.Body>
                </Card>
              </Form>
            </Row>
            {id && isSuper && (
              <Row><Col xl={12} lg={12}><UnitColorsPanel localityId={id} localityName={resultList?.name} /></Col></Row>
            )}
          </Fragment>
        ) : (
          <Fragment>
            <Row>
              <Col xl={12} lg={12}>
                <Card>
                  <Card.Body className="py-1 px-1 border-bottom border-light">
                    <div className="d-flex align-items-center justify-content-between">
                      <div className="float-start">
                        <OverlayTrigger
                          placement="bottom"
                          overlay={<Tooltip id="">Back</Tooltip>}
                        >
                          <Link
                            to="/locality/list"
                            className="text-reset fs-20 p-1 d-inline-block"
                          >
                            <i
                              className="ri-arrow-left-s-line pe-2"
                              data-bs-container="#tooltips-container"
                              data-bs-toggle="tooltip"
                            />
                          </Link>
                        </OverlayTrigger>
                        <label className="form-check-label fs-16">
                          Locality Information
                        </label>
                      </div>
                      {permission.includes("lou") && <div id="tooltips-container d-flex align-items-center">
                        <div className="d-flex flex-wrap gap-2">
                          <OverlayTrigger
                            placement="bottom"
                            overlay={<Tooltip id="">Edit</Tooltip>}
                          >
                            <Button
                              className="btn btn-light"
                              onClick={() => {
                                navigate(`/locality/form?id=${id}&mode=edit`);
                              }}
                            >
                              <i
                                className="ri-edit-2-line"
                                data-bs-container="#tooltips-container"
                                data-bs-toggle="tooltip"
                              />
                            </Button>
                          </OverlayTrigger>
                        </div>
                      </div>}
                    </div>
                  </Card.Body>
                </Card>
              </Col>
            </Row>

            <Row>
              <Col>
                <Card>
                  <Card.Body>
                    <Form>
                      <Row>
                        <Col md={4}>
                          <Form.Group className="mb-3">
                            <Form.Label>Name</Form.Label>
                            <p className="text-muted fs-14">{resultList.name || "-"}</p>
                          </Form.Group>
                        </Col>
                        <Col md={4}>
                          <Form.Group className="mb-3">
                            <Form.Label>State</Form.Label>
                            <p className="text-muted fs-14">{resultList.state || "-"}</p>
                          </Form.Group>
                        </Col>
                        {/* <Col md={4}>
                          <Form.Group className="mb-3">
                            <Form.Label>Latitude</Form.Label>
                            <p className="text-muted fs-14">{resultList.latitude || "-"}</p>
                          </Form.Group>
                        </Col>
                        <Col md={4}>
                          <Form.Group className="mb-3">
                            <Form.Label>Longtitude</Form.Label>
                            <p className="text-muted fs-14">{resultList.longitude || "-"}</p>
                          </Form.Group>
                        </Col> */}
                        <Col md={4}>
                          <Form.Group className="mb-3">
                            <Form.Label>Subscriber Only Comment</Form.Label>
                            <p className="text-muted fs-14">
                              {Boolean(resultList.subscriberOnlyComment) == true ? "Y" : "N"}
                            </p>
                          </Form.Group>
                        </Col>
                        <Col md={4}>
                          <Form.Group className="mb-3">
                            <Form.Label>News Url</Form.Label>
                            <p className="text-muted fs-14">{resultList.newsRssFeedURL || "-"}</p>
                          </Form.Group>
                        </Col>

                        <Col md={4}>
                          <Form.Group className="mb-3">
                            <Form.Label>Twitter Description</Form.Label>
                            <p className="text-muted fs-14">{resultList.twitterPage || "-"}</p>
                          </Form.Group>
                        </Col>
                        <Col md={4}>
                          <Form.Group className="mb-3">
                            <Form.Label>Twitter API Key</Form.Label>
                            <p className="text-muted fs-14">{resultList.twitterAppKey || "-"}</p>
                          </Form.Group>
                        </Col>
                        <Col md={4}>
                          <Form.Group className="mb-3">
                            <Form.Label>Twitter Access Token</Form.Label>
                            <p className="text-muted fs-14">{resultList.twitterAccessToken || "-"}</p>
                          </Form.Group>
                        </Col>
                        <Col md={4}>
                          <Form.Group className="mb-3">
                            <Form.Label>Twitter Access Token Secret</Form.Label>
                            <p className="text-muted fs-14">{resultList.twitterAccessSecret || "-"}</p>
                          </Form.Group>
                        </Col>
                        <Col md={4}>
                          <Form.Group className="mb-3">
                            <Form.Label>Twitter Bearer Token</Form.Label>
                            <p className="text-muted fs-14">{resultList.twitterBearerToken || "-"}</p>
                          </Form.Group>
                        </Col>

                        {permission.includes("lod") && <Col md={4}>
                          <Button
                            variant="danger"
                            size="sm"
                            className="me-1 d-felx align-items-center"
                            onClick={() => setConfirm({ id: id, type: "locality" })}
                          >
                            <i className="ri-delete-bin-line fs-16" />
                            <span className="ms-1">Permanently Delete Locality</span>
                          </Button>
                        </Col>}
                        <label className="form-check-label fs-16 mb-3">
                          Definition Information
                        </label>
                        <Col md={4}>
                          <Form.Group className="mb-3">
                            <Form.Label>Field1 Name</Form.Label>
                            <p className="text-muted fs-14">{resultList.field1Name || "-"}</p>
                          </Form.Group>
                        </Col>
                        <Col md={4}>
                          <Form.Group className="mb-3">
                            <Form.Label>Field2 Name</Form.Label>
                            <p className="text-muted fs-14">{resultList.field2Name || "-"}</p>
                          </Form.Group>
                        </Col>
                        <Col md={4}>
                          <Form.Group className="mb-3">
                            <Form.Label>Field3 Name</Form.Label>
                            <p className="text-muted fs-14">{resultList.field3Name || "-"}</p>
                          </Form.Group>
                        </Col>
                        <Col md={4}>
                          <Form.Group className="mb-3">
                            <Form.Label>Field4 Name</Form.Label>
                            <p className="text-muted fs-14">{resultList.field4Name || "-"}</p>
                          </Form.Group>
                        </Col>
                        <Col md={4}>
                          <Form.Group className="mb-3">
                            <Form.Label>Field5 Name</Form.Label>
                            <p className="text-muted fs-14">{resultList.field5Name || "-"}</p>
                          </Form.Group>
                        </Col>
                      </Row>
                    </Form>
                  </Card.Body>
                </Card>
              </Col>
            </Row>
            {id && isSuper && (
              <Row><Col xl={12} lg={12}><UnitColorsPanel localityId={id} localityName={resultList?.name} /></Col></Row>
            )}
          </Fragment>
        )}
      </Fragment>
      )}

      {/* Delete confirmation */}
      {confirm.id && (
        <AgDelete
          type="delete"
          onAgDeleteCallBack={deleteCallBack}
        />
      )}
    </Fragment>
  );
}
